import React, { useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

import { CustomerContext } from '../../../contexts/customer-context';

import RegisterForAccessForm from './register-for-access-form';
import RegisterForAccessFormKp from './register-for-access-form-kp';
import RegisterForAccessFormKpEvent from './register-for-access-form-kp-event';

const RegisterForAccess = () => {
	const {
		customerCode = '',
	} = useContext(CustomerContext);
	const { data } = useOutletContext();

	return (
		<>
			{customerCode === 'KP' ? (
				<>
					{data.bodyType === 'MSG' ? (
						<RegisterForAccessFormKpEvent />
					) : (
						<RegisterForAccessFormKp />
					)}
				</>
			) : (
				<RegisterForAccessForm />
			)}
		</>
	);
};

export default RegisterForAccess;
